import React, { useState } from "react";
import "./Gallery.css";
import waheedback from "../../assets/icons/bg.svg";
import galleryhead from "../../assets/galleryhead.svg";
import qima1 from "../../assets/gallery/qima1.jpeg";
import qima2 from "../../assets/gallery/qima2.jpeg";
import qima3 from "../../assets/gallery/qima3.svg";
import qima4 from "../../assets/gallery/qima4.jpeg";
import yearly from "../../assets/gallery/2023.jpeg";
import yearly2 from "../../assets/gallery/20232.jpeg";
import yearly3 from "../../assets/gallery/20233.JPG";
import yearly4 from "../../assets/gallery/20234.JPG";
import yearly5 from "../../assets/gallery/20235.JPG";
import FD from "../../assets/gallery/FD.jpeg";
import FD2 from "../../assets/gallery/FD2.png";
import FD3 from "../../assets/gallery/FD3.png";
import FD4 from "../../assets/gallery/FD4.jpeg";
import FD5 from "../../assets/gallery/FD5.jpeg";
import FD6 from "../../assets/gallery/FD6.jpeg";
import FD7 from "../../assets/gallery/FD7.png";
import FD8 from "../../assets/gallery/FD8.png";
import yearly6 from "../../assets/gallery/2022.jpg";
import yearly7 from "../../assets/gallery/20222.jpg";
import yearly8 from "../../assets/gallery/20223.jpg";
import yearly9 from "../../assets/gallery/20224.jpg";
// import yearly10 from "../../assets/gallery/20225.jpg";
import yearly10 from "../../assets/gallery/20225.jpg";
import yearly11 from "../../assets/gallery/20226.jpg";
import yearly12 from "../../assets/gallery/20227.jpg";
import yearly13 from "../../assets/gallery/20228.jpg";
import yearly14 from "../../assets/gallery/20229.jpg";
import yearly15 from "../../assets/gallery/202210.jpg";
import album5 from "../../assets/gallery/album5.jpeg";
import album52 from "../../assets/gallery/album52.jpeg";
import album53 from "../../assets/gallery/album53.jpeg";
import album6 from "../../assets/gallery/album6.jpeg";
import album62 from "../../assets/gallery/album62.jpeg";
import album63 from "../../assets/gallery/album63.jpeg";
import yearly16 from "../../assets/gallery/yearly21.JPG";
import yearly17 from "../../assets/gallery/yearly212.JPG";
import yearly18 from "../../assets/gallery/yearly213.JPG";
import yearly19 from "../../assets/gallery/yearly214.JPG";
import yearly20 from "../../assets/gallery/yearly215.JPG";
import yearly21 from "../../assets/gallery/yearly216.JPG";

import yearly22 from "../../assets/gallery/yearly217.jpeg";
import yearly23 from "../../assets/gallery/yearly218.JPG";
import yearly24 from "../../assets/gallery/yearly219.jpeg";
import yearly25 from "../../assets/gallery/yearly2110.jpeg";
import yearly26 from "../../assets/gallery/yearly2111.jpeg";
import propTech1 from "../../assets/gallery/propTech1.jpg";
import propTech2 from "../../assets/gallery/propTech2.jpg";
import Table1 from "../../assets/gallery/Table 1.jpg";
import Table2 from "../../assets/gallery/Table 2.jpg";
import Table3 from "../../assets/gallery/Table 3.jpg";
import A23 from "../../assets/gallery/230.jpg";
import A1 from "../../assets/gallery/23-1P.jpg";
import A2 from "../../assets/gallery/23-2.jpg";
import A3 from "../../assets/gallery/23-3.jpg";
import A4 from "../../assets/gallery/23-4.jpg";
import A5 from "../../assets/gallery/23-5.jpg";
import A6 from "../../assets/gallery/23-6.jpg";
import A7 from "../../assets/gallery/23-7.jpg";
import A8 from "../../assets/gallery/23-8.jpg";
import A9 from "../../assets/gallery/23-9.jpg";
import A10 from "../../assets/gallery/23-10.jpg";
import A11 from "../../assets/gallery/23-11.jpg";
import A12 from "../../assets/gallery/23-12.jpg";
import A13 from "../../assets/gallery/23-13.jpg";
import A14 from "../../assets/gallery/23-14.jpg";
import A15 from "../../assets/gallery/23-15.jpg";

import { useTranslation } from "react-i18next";

export default function Gallery() {
  const { t } = useTranslation();
  const albumImages = [
    [propTech1, propTech2],
    [Table1, Table2, Table3],
    [  A14 , A1, A23,  A2, A3, A4, A5, A6, A7, A8, A9, A10, A11, A12, A13],
    [FD, FD2, FD3, FD4, FD5, FD6, FD7, FD8],
    [yearly4, yearly, yearly2, yearly3, yearly5],
    [
      yearly11,
      yearly6,
      yearly7,
      yearly8,
      yearly9,
      yearly10,
      yearly12,
      yearly13,
      yearly14,
      yearly15,
    ],
    [qima1, qima2, qima3, qima4],
    [album6, album62, album63],
    [
      yearly22,
      yearly16,
      yearly17,
      yearly18,
      yearly19,
      yearly20,
      yearly21,
      yearly23,
      yearly24,
      yearly25,
      yearly26,
    ],
    [album5, album52, album53],
    
  ];
  const [thumbnailStartIndex, setThumbnailStartIndex] = useState(0);
  const albums = t("albums.events", { returnObjects: true });
  const albumsWithImages = albums.map((album, index) => ({
    ...album,
    images: albumImages[index] || [qima1],
  }));
  const [selectedGallery, setSelectedGallery] = useState(albumsWithImages[0]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [expandedAlbumIndex, setExpandedAlbumIndex] = useState(null);
  const handleViewGallery = (index) => {
    setExpandedAlbumIndex(expandedAlbumIndex === index ? null : index);
    setSelectedGallery(albumsWithImages[index]);
    setCurrentIndex(0);
     window.scrollTo({
       top: 0,
       behavior: "smooth",
     });    
  };
  const handleNext = () => {
    const newIndex = (currentIndex + 1) % (selectedGallery?.images.length || 1);
    setCurrentIndex(newIndex);
      if (newIndex >= thumbnailStartIndex + 4) {
      setThumbnailStartIndex(thumbnailStartIndex + 1);
    }
  };
  const handlePrev = () => {
    const newIndex =
      (currentIndex - 1 + (selectedGallery?.images.length || 1)) %
      (selectedGallery?.images.length || 1);
    setCurrentIndex(newIndex);
    
    if (newIndex < thumbnailStartIndex) {
      setThumbnailStartIndex(thumbnailStartIndex - 1);
    }
  };
  const handleThumbnailNext = () => {
    if (thumbnailStartIndex + 4 < selectedGallery?.images.length) {
      setThumbnailStartIndex(thumbnailStartIndex + 1);
    }
  };
  const handleThumbnailPrev = () => {
    if (thumbnailStartIndex > 0) {
      setThumbnailStartIndex(thumbnailStartIndex - 1);
    }
  };
  
  return (
    <div>
      <div className="gallery-container">
        <img src={waheedback} className="gallery-bg" alt="background" />

        {selectedGallery && (
          <div className="main-image">
            <img
              src={selectedGallery.images[currentIndex]}
              alt="Selected Gallery"
            />
          </div>
        )}
 
        <div className="thumbnail-container">
          {/* <button className="nav-btn left" onClick={handlePrev}>
            ◀
          </button> */}

          <button 
          className="nav-btn left" 
          onClick={handleThumbnailPrev}
          disabled={thumbnailStartIndex === 0}
        >
          ◀
        </button>

          {/* <div className="thumbnails">
            {selectedGallery?.images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Thumbnail ${index}`}
                className={`thumbnail ${
                  index === currentIndex ? "active" : ""
                }`}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div> */}

          <div className="thumbnails">
          {selectedGallery?.images
            .slice(thumbnailStartIndex, thumbnailStartIndex + 4)
            .map((img, index) => (
              <img
                key={thumbnailStartIndex + index}
                src={img}
                alt={`Thumbnail ${thumbnailStartIndex + index}`}
                className={`thumbnail ${
                  thumbnailStartIndex + index === currentIndex ? "active" : ""
                }`}
                onClick={() => setCurrentIndex(thumbnailStartIndex + index)}
              />
            ))}
        </div>

          {/* <button className="nav-btn right" onClick={handleNext}>
            ▶
          </button> */}
          <button 
          className="nav-btn right" 
          onClick={handleThumbnailNext}
          disabled={thumbnailStartIndex + 4 >= (selectedGallery?.images.length || 0)}
        >
          ▶
        </button>
        </div>
      </div>

      <div className="galleries">
        {/* <h1>{t("album")}</h1> */}
        <div className="galleries-container">
          {albumsWithImages.map((album, index) => (
            <div className="gallery-card" key={index}>
              <div className="gallery-images">
                <img
                  src={album.images[0]}
                  alt={`${album.title} - Main`}
                  className="main-img"
                />

                {/* Show other images only if the album is expanded
                {expandedAlbumIndex === index &&
                  album.images
                    .slice(1)
                    .map((image, imgIndex) => (
                      <img
                        key={imgIndex}
                        src={image}
                        alt={`${album.title} - ${imgIndex + 2}`}
                      />
                    ))} */}
              </div>

              <div className="card-content">
                <div className="card-header">
                  <a href="#" className="card-title">
                    {album.title}
                  </a>
                  <p className="card-date">{album.date}</p>
                </div>
                <p className="card-description">{album.description}</p>
                <div className="card-footer">
                  <button
                    className="view-button"
                    onClick={() => handleViewGallery(index)}
                  >
                    {t("albums.view_button")}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
